// Free-to-use portraits from Wikimedia Commons (via Wikipedia)
export const TAMIL_CINEMA_STARS = [
  {
    name: 'Rajinikanth',
    image: 'https://upload.wikimedia.org/wikipedia/commons/thumb/d/d2/Rajinikanth_in_2019.jpg/330px-Rajinikanth_in_2019.jpg',
  },
  {
    name: 'Vijay',
    image: 'https://upload.wikimedia.org/wikipedia/commons/thumb/0/06/C._Joseph_Vijay_%28cropped%29.jpg/330px-C._Joseph_Vijay_%28cropped%29.jpg',
  },
  {
    name: 'Kamal Haasan',
    image: 'https://upload.wikimedia.org/wikipedia/commons/thumb/a/a3/Kamal_Haasan_at_2023_San_Diego_Comic-Con_International_by_Gage_Skidmore%2C_005_%28cropped%29.jpg/330px-Kamal_Haasan_at_2023_San_Diego_Comic-Con_International_by_Gage_Skidmore%2C_005_%28cropped%29.jpg',
  },
  {
    name: 'Ajith Kumar',
    image: 'https://upload.wikimedia.org/wikipedia/commons/thumb/3/3f/Ajith_Kumar_at_Irungattukottai_Race_Track.jpg/330px-Ajith_Kumar_at_Irungattukottai_Race_Track.jpg',
  },
  {
    name: 'Suriya',
    image: 'https://upload.wikimedia.org/wikipedia/commons/thumb/7/7d/Retro_audio_launch_-_Suriya.jpg/330px-Retro_audio_launch_-_Suriya.jpg',
  },
  {
    name: 'Dhanush',
    image: 'https://upload.wikimedia.org/wikipedia/commons/thumb/8/89/Dhanush_at_the_%E2%80%98Asuran%E2%80%99_Success_Meet_%28cropped%29.jpg/330px-Dhanush_at_the_%E2%80%98Asuran%E2%80%99_Success_Meet_%28cropped%29.jpg',
  },
  {
    name: 'Nayanthara',
    image: 'https://upload.wikimedia.org/wikipedia/commons/thumb/8/80/Nayanthara_at_Filmfare_Awards.jpg/330px-Nayanthara_at_Filmfare_Awards.jpg',
  },
  {
    name: 'Trisha',
    image: 'https://upload.wikimedia.org/wikipedia/commons/thumb/3/3a/Trisha_Krishnan_at_PS1_pre_release_event_%283%29_%28cropped%29.jpg/330px-Trisha_Krishnan_at_PS1_pre_release_event_%283%29_%28cropped%29.jpg',
  },
  {
    name: 'Vikram',
    image: 'https://upload.wikimedia.org/wikipedia/commons/thumb/2/2b/Vikram_at_the_%E2%80%98Kadaram_Kondan%E2%80%99_Press_Meet.jpg/330px-Vikram_at_the_%E2%80%98Kadaram_Kondan%E2%80%99_Press_Meet.jpg',
  },
  {
    name: 'Sivakarthikeyan',
    image: 'https://upload.wikimedia.org/wikipedia/commons/thumb/7/76/Sivakarthikeyan_%28cropped%29.jpg/330px-Sivakarthikeyan_%28cropped%29.jpg',
  },
];
